module.exports = __webpack_public_path__ + "static/img/30016 (1).4576981.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30016 (1).webp
// module id = uVPB
// module chunks = 14